export default __webpack_public_path__ + "static/media/11.e6dc708d.svg";